import { cast } from 'redpoints-front-common/helpers';

export const filtersCastOptions = {
  domainUrl: value => cast.string(value, null),
  filterByCustomer: value => cast.bool(value, null),
};
